import { RazorInputField } from "../components/razor-reuse";
import { debounce } from "lodash";
import React from "react";
import { ALL_ICONS } from "../assets/icons/AllIcons";
import "../styles/components/FilterReusableComp.css";

interface myComponentProps {
  searchPlaceholder?: string;
  selectOneList?: any;
  selectOneValue?: any;
  onSelectOne?: (param: any) => void;
  selectTwoList?: any;
  defaultSelectOne?: string;
  defaultSelectTwo?: string;
  selectTwoValue?: any;
  onSelectTwo?: (param: any) => void;
  hideExport?: boolean;
  onExport?: () => void;
  hideSearch?: boolean;
  hideFilter?: boolean;
  children?: React.ReactNode;
  onSearch?: (param: any) => void;
  className?: string;
  formatOptionLabelTwo?: any;
  formatOptionLabelOne?: any;
  selectWidthOne?: string;
  selectWidthTwo?: string;
  moreComponents?: any;
}

const FilterReusableComp = ({
  searchPlaceholder,
  selectOneList,
  onSelectOne,
  onSelectTwo,
  defaultSelectOne,
  defaultSelectTwo,
  selectOneValue,
  selectTwoList,
  selectTwoValue,
  hideExport,
  onExport,
  hideSearch,
  children,
  onSearch,
  className,
  formatOptionLabelTwo,
  formatOptionLabelOne,
  selectWidthOne,
  hideFilter,
  selectWidthTwo,
  moreComponents,
}: myComponentProps) => {
  return (
    <div
      className={`filter-reusable-comp-wrapper-index ${
        className ? className : ""
      }`}
    >
      {/* children box start */}
      {children && <div className="children-box">{children}</div>}
      {/* children box end */}
      {/* search box start */}
      {!hideSearch && (
        <div className="smart-send-search-box">
          <RazorInputField
            type="search"
            className="search-input"
            placeholder={searchPlaceholder || "Search"}
            color="black-light"
            onChange={debounce((e: any) => {
              onSearch?.(e.target.value);
            }, 1000)}
          />
        </div>
      )}
      {/* search box end */}
      {/* filter export box start */}
      <div className="filter-export-box">
        {/* select one start */}
        {selectOneList?.length > 0 && (
          <RazorInputField
            color="black-light"
            className={`select-input ${
              selectWidthOne ? "select-input-one" : ""
            }`}
            type="select"
            placeholder=" "
            value={
              selectOneValue || {
                label: defaultSelectOne || "Filter By:",
                value: "",
              }
            }
            style={
              {
                "--select-width-one": selectWidthOne || "max-content",
                // "--select-width-two": selectWidthTwo || "max-content",
              } as React.CSSProperties
            }
            onChange={(param: any) => {
              if (param?.label !== selectOneValue?.label) {
                onSelectOne?.(param);
              }
            }}
            selectOption={selectOneList}
            formatOptionLabel={formatOptionLabelOne}
          />
        )}
        {/* select one end */}
        {/* select one start */}
        {selectTwoList?.length > 0 && (
          <RazorInputField
            color="black-light"
            className={`select-input ${
              selectWidthTwo ? "select-input-two" : ""
            }`}
            type="select"
            placeholder=" "
            value={
              selectTwoValue || {
                label: defaultSelectTwo || "Filter By:",
                value: "",
              }
            }
            onChange={(param: any) => {
              if (param?.label !== selectTwoValue?.label) {
                onSelectTwo?.(param);
              }
            }}
            selectOption={selectTwoList}
            formatOptionLabel={formatOptionLabelTwo}
            // selectMenuOpen={true}
            style={
              {
                // "--select-width-one": selectWidthOne || "max-content",
                "--select-width-two": selectWidthTwo || "max-content",
              } as React.CSSProperties
            }
          />
        )}
        {/* select one end */}
        {/* export box start */}
        {!hideExport && (
          <div
            onClick={() => {
              onExport?.();
            }}
            className="export-box-wrap"
          >
            <div className="icon-box">
              <figure className="img-box">{ALL_ICONS?.export_down_icon}</figure>
            </div>
            <p className="text">{`Export`}</p>
          </div>
        )}
        {/* export box end */}
        {/* more component start here */}
        {moreComponents}
        {/* more comp end here */}
      </div>
      {/* filter export box end */}
    </div>
  );
};

export default FilterReusableComp;
